import { useForm } from "@inertiajs/react"
import formatDate from "@/utils/formatDate"
import { AdminPromotion } from "@/types/serializers"
import { Modals, useModals } from "@/hooks/useModals"
import PromotionManagers from "./PromotionManagers"
import Button from "./Button"

const PromotionItem = ({
  promotion,
  setSelectedPromotion,
}: {
  promotion: AdminPromotion
  setSelectedPromotion: (promotion: AdminPromotion | null) => void
}) => {
  const { openModal } = useModals()

  const { delete: destroy, processing } = useForm()

  const handleDelete = () => {
    const confirmation = confirm(
      "Are you sure you want to delete this promotion?"
    )

    if (!confirmation) return

    destroy(`/admin/promotions/${promotion.id}`, {
      async: true,
      preserveScroll: true,
      preserveState: true,
    })
  }

  return (
    <li className="overflow-hidden rounded-2xl border border-gray-100 bg-white px-4 pt-5 pb-6 shadow sm:px-6">
      <div>
        <h3 className="text-base font-semibold text-gray-900">
          {promotion.title}
        </h3>
        <p className="mt-1 flex text-sm text-gray-500">
          {formatDate({
            date: promotion.start_at,
            format: "long",
          })}{" "}
          –{" "}
          {formatDate({
            date: promotion.end_at,
            format: "long",
          })}
        </p>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2">
        <Button
          size="sm"
          style="secondary"
          href={`/p/${promotion.slug}`}
          target="_blank"
          rel="noreferrer noopener"
          disabled={processing}
          asAnchorTag
        >
          View
        </Button>
        <Button
          size="sm"
          style="secondary"
          href={`/p/${promotion.slug}/manage`}
          target="_blank"
          rel="noreferrer noopener"
          disabled={processing}
          asAnchorTag
        >
          Tweets
        </Button>
        <Button
          size="sm"
          style="secondary"
          onClick={() => {
            setSelectedPromotion(promotion)
            openModal(Modals.Promotion)
          }}
          disabled={processing}
        >
          Edit
        </Button>
        <Button
          size="sm"
          style="secondary"
          onClick={handleDelete}
          loading={processing}
        >
          Delete
        </Button>
      </div>

      <PromotionManagers promotion={promotion} />
    </li>
  )
}

export default PromotionItem
